import { PriceTabGrid } from "../price/priceTabGrid.tsx";

/**
 * Edit-Location → Prices tab. Server-paged per-product price summary
 * (LOCATIONPRICEGRID): one row per recent-inventory product across the
 * location's kiosks, with the location-effective Current Price/Tax, the
 * resolved Source, an editable location-level override value per price type,
 * and a DiffCount drill-down listing kiosks whose actual price diverges from
 * the location price (lazily fetched via getLocationProductKioskDivergence).
 * Replaces the old load-everything cascade table.
 */
export function LocationPricesTab({ locationId, onReady }: { locationId: number; onReady?: () => void }) {
  return (
    <PriceTabGrid
      gridName="LOCATIONPRICEGRID"
      scope={{ kind: "location", locationId }}
      scopeParamColumn="LocationID"
      scopeParamValue={locationId}
      onReady={onReady}
    />
  );
}
